const generateTitle = (str: string) =>
  str
    .split(" ")
    .slice(0, 2)
    .map((e) => e.charAt(0).toUpperCase())
    .join("");

export default generateTitle;
